import {MenuItemType} from '@models/sidebar/menu-item-type';
import {MenuItem} from '@models/sidebar/menu-item';

export class PageGlobalParameters {
  pageName: string = '';
  pageType: MenuItemType = MenuItemType.NONE;
  parentType: MenuItemType = MenuItemType.NONE;
  machineId: string = '';
  organizationId: string = '';
  pageId: string = '';
  machineCategory: string = '';
  embeddedContendUrl: string = '';
  /**
   * @deprecated - use firebaseUserId
   */
  userId: number = 0;
  firebaseUserId: string = '';
  widgetInformation: any;
  interactiveDataAnalysisMenuItem: MenuItem | undefined;
  machineryGroupId: string = '';
  associatedMenuItem: MenuItem = new MenuItem();
}
